const AccountTypes = {
  CONSUMER_SAVINGS: 'S',
  CORPORATE_SAVINGS: 'Y',
  CONSUMER_CHECKING: 'C',
  CORPORATE_CHECKING: 'X',
}

export default AccountTypes
